/* eslint-disable require-jsdoc */
import { connect } from 'react-redux';
import ContentPage from './content-page';
import { selectFilteredNews } from 'app/selectors/filtered-news';
import selectGlobalFields from 'app/selectors/global-fields';
import selectPage, {
    featuredNewsSelector,
    latestNewsSelector,
    newsCategoriesSelector,
    newsSubCategoriesSelector,
    popularNewsSelector
} from 'app/selectors/page';

function mapStateToProps(state) {
    const pathname = state.router.location.pathname;

    return {
        page: selectPage(state, pathname),
        featuredNews: featuredNewsSelector(state, pathname),
        latestNews: latestNewsSelector(state, pathname),
        // Only to tell an empty page of the listing from one still loading, for
        // the robots tag
        listingItems: selectFilteredNews(state),
        newsCategories: newsCategoriesSelector(state, pathname),
        newsSubCategories: newsSubCategoriesSelector(state, pathname),
        popularNews: popularNewsSelector(state, pathname),
        globalFields: selectGlobalFields(state)
    };
}

const VisibleContentPage = connect(mapStateToProps)(ContentPage);

export default VisibleContentPage;
